<app-stages [stages]="stages" currentStage="Dane nieruchomości">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate [formGroup]='form' (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      @if (form.street) {
        <div class='col-md-6'>
          <div class='form-group' *ngIf='"street" as controlName'>
            <label [for]='controlName'>
              Ulica
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nazwę ulicy'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.houseNumber; as control) {
        <div class='col-md-6'>
          <div class='form-group' *ngIf='"houseNumber" as controlName'>
            <label [for]='controlName'>
              Numer adresowy
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu numer adresowy'
              type='text'>
            <app-validation-errors [control]='control'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    <fieldset>
      <legend>
        Działka(i)
      </legend>
      <app-parcels-crud [hideContentControl]="true" formControlName="parcels">
      </app-parcels-crud>
    </fieldset>
    <br>
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
